export default __webpack_public_path__ + "static/media/dashboard.dabb119a.svg";